import { Box, Group, Stack, Text } from '@mantine/core';
import { chunk } from 'remeda';

import { type PaidByReminderSegment, segmentKey } from './paid-by-reminder-segments';

const ENTRIES_PER_ROW = 4;

const LIST_RESET = { padding: 0, listStyleType: 'none' } as const;

type PaidByReminderStageLegendProps = {
  segments: ReadonlyArray<PaidByReminderSegment>;
};

export const PaidByReminderStageLegend = ({ segments }: PaidByReminderStageLegendProps) => (
  <Stack gap={4}>
    {chunk([...segments], ENTRIES_PER_ROW).map(row => (
      <Group
        key={row.map(segmentKey).join('-')}
        component="ul"
        gap="md"
        justify="center"
        style={{ ...LIST_RESET, rowGap: 4 }}
      >
        {row.map(segment => (
          <Group key={segmentKey(segment)} component="li" gap={6} wrap="nowrap">
            <Box
              aria-hidden
              w={10}
              h={10}
              style={{ borderRadius: 3, backgroundColor: segment.color, flexShrink: 0 }}
            />
            <Text size="xs" c="gray.7" style={{ whiteSpace: 'nowrap' }}>
              {segment.label}
            </Text>
          </Group>
        ))}
      </Group>
    ))}
  </Stack>
);
